<template>
    <div class="table-wrapper">

        <vue-table :loading="loading">
            <tr slot="thead">
                <th width="12%">编号</th>
                <th>姓名</th>
                <th width="19%">手机号</th>
                <th width="18%">所属部门</th>
                <th width="290">操作</th>
            </tr>
            <tr slot="tbody" v-for="(item,index) in listData">
                <td>{{item.uid}}</td>
                <td class="td-name">
                    <img class="user-logo" :src="item.logo" :onerror="'this.src=\''+ require('@/assets/images/new-default-head.png')+'\'' " />
                    <span :class="'user-name '+(item.islogin==='2' ? 'red' : '')">{{item.username}}</span> &nbsp;&nbsp;&nbsp;<i v-if="(item.unionid && item.unionid !== '0')" title="已绑定微信" class="fa fa-weixin wexin-green"></i> <i v-if="(item.isBinding === '1')" title="已关注公众号" class="fa fa-weixin wexin-blue"></i>
                </td>
                <td>
                    <span v-if="showPhoneNum(index)">{{item.tkphone|phoneShow}}</span>
                    <span v-else>{{item.tkphone}}</span>
                    <a @click="showNum(index)" style="padding-left: 30px">查看</a>
                </td>
                <td>{{item.groupname}}</td>
                <td class="td-wrap">
                    <div class="operat-btn operat-btn-blue" @click="toDetail(item.uid)">
                        <i class="fa fa-eye"></i>
                        <span>查看</span>
                    </div>
                    <div v-if="authList.card" class="operat-btn operat-btn-blue" @click="toCard(item.uid)">
                        <i class="fa fa-newspaper-o"></i>
                        <span>查看名片统计</span>
                    </div>
                    <div v-if="authList.ban" :class="'operat-btn operat-btn-blue' + (item.islogin==='2' ? '  ' : ' red-btn ')" @click="changeUserStatus(item.uid,item.islogin,item.username)">
                        <template v-if="item.islogin == '1'">
                            <i class="fa fa-ban"></i>
                            <span>禁止</span>
                        </template>
                        <template v-else>
                            <i class="fa fa-check-circle-o"></i>
                            <span>解除</span>
                        </template>
                    </div>
                </td>
            </tr>
        </vue-table>
        <div class="list-bottom">
            <div class="page">
                <Page @on-change="handlePage" @on-page-size-change="handlePageSize" :placement="'top'" :current="page" :page-size="pageSize" :total="count" show-elevator show-sizer show-total></Page>
            </div>
        </div>
        <warning ref="userwarn" :title="warning.title" @callback="doChangeUserStatus">
            <div  slot="body"><p>{{warning.tip}}</p></div>
        </warning>
    </div>
</template>

<script>
    import baseAuthEnum from "@/staticData/baseAuthEnum";
    import warning from "@/components/warningModal/Warning.vue";
    import VueTable from "@/components/table/Table.vue";
    import utils from "@/utils";
    export default {
        components: {
            VueTable,
            warning,
            utils
        },
        props:{
            loading : true,
            listData : Array,
            count : 0,
        },
        data(){
            return {
                page: 1,
                pageSize : 10,
                showNumIndex : [-1],
                //修改用户提示框内容
                warning : {
                    title : "",
                    tip : "",
                },
                //待修改状态的用户信息
                changeUser : {
                    uid : "0",
                    islogin: "2",
                },
                //页面权限
                authList : {
                    card : false,   //查看名片统计权限
                    auth : false,   //设置权限权限
                    ban  : false,   //禁止用户权限
                }
            }
        },
        created() {
            this.getAuth();
        },
        methods : {
            //初始化手机号隐藏
            initShowPhoneNum(){
                this.showNumIndex = [-1];
            },
            //获取权限
            getAuth(){
                let obj = {
                    card : utils.judgeAuth([baseAuthEnum.WATCH_CARD_RECORD],1),
                    auth : utils.judgeAuth([baseAuthEnum.AUTH_SETTING],1),
                    ban  : utils.judgeAuth([baseAuthEnum.CHANGE_USER_STATUS],1),
                };
                this.authList = Object.assign({},obj);
            },
            //修改每页条数操作
            handlePage(page){
                this.page = page;
                let _self = this;
                this.$emit('selectPage',
                    {
                        'page' : page,
                        'pageSize' : _self.pageSize
                    }
                );
            },
            //修改每页显示数
            handlePageSize(pageSize){
                this.pageSize = pageSize;
                let _self = this;
                this.$emit('selectPage',
                    {
                        'page' : _self.page,
                        'pageSize' : pageSize
                    }
                );
            },
            //改变用户状态
            changeUserStatus(id,status,name){
                let _self = this;
                this.warning = Object.assign({
                    title : "",
                    tip : "",
                },{
                    title : status==="1" ? "禁止登录确认" : "解除禁止登录确认",
                    tip : status === "1" ? "您确定将 "+name+" 禁止登录吗？" : "您确定将 "+name+" 解除禁止登录吗？",
                });
                this.$refs.userwarn.show();

                this.changeUser = Object.assign({
                    uid : "0",
                    islogin: "2",
                },{
                    'uid'   :   id,
                    'islogin': status === "1" ? "2":"1",
                });
            },
            doChangeUserStatus(){
                this.$refs.userwarn.doLoading();
                this.$emit('changeUserStatus',this.changeUser)
            },
            finishChangeUserStatus(){
                this.$refs.userwarn.noLoading();
                this.$refs.userwarn.hide();
                let notice = "";
                if(this.changeUser.islogin==="2"){
                    notice = "禁止登录成功";
                }else{
                    notice = "解除禁止登录成功"
                }
                utils.notice(notice,"success");
            },
            //更改状态用户状态操作
            handleUser(status){
                this.$emit('changeUserStatus',status);
            },
            //手动设置页码及页面条数
            setPageOptions(page,pageSize) {
                this.page = page ? parseInt(page) : 0;
                this.pageSize = pageSize ? parseInt(pageSize) : 10;
            },
            //查看手机号
            showNum(index){
                let _self = this;
                if( !(index !==0 &&!index)){
                    _self.showNumIndex.splice(-1,0,index);
                }
            },
            //决定是否显示手机号
            showPhoneNum(index){
                let status = false;
                for(let i = 0 ; i <= this.showNumIndex.length; i++){
                    if(this.showNumIndex[i] === index){
                        status = true;
                        break;
                    }
                }
                return !status;
            },
            //查看用户详情页
            toDetail(id){
                this.$router.push(
                    {
                        name : "company-member-detail",
                        params : {id:id},
                    }
                )
            },
            //跳转名片统计页
            toCard(uid){
                this.$router.push({
                    name : "company-member-card-record",
                    params : {uid:uid},
                })
            }
        },
        filters: {
            phoneShow(str){
                let newStr = '';
                if(str){
                    newStr = str.slice(0,4)+"****"+str.slice(7);
                }

                return newStr;
            },
        },
    }
</script>

<style scoped>
    @import "./listTable.less";
</style>


// WEBPACK FOOTER //
// src/pages/company/member/business/ListTable.vue